import Header from '../components/Header';
import Footer from '../components/Footer';
import BackBtn from '../components/BackBtn';
import myDetails from '../assets/myDetails.json';

function Skills() {

    const page_title = "Skills";

    return (
        <div className='home-main'>
            <div className='sub-sec'>
                <Header title={page_title} />
                <div className='body-grid'>
                    <div>
                        <div className="grid-title">Programming Languages</div>
                        <hr></hr>
                        <div className='cnt-grid-logo'>
                            {
                                myDetails.skills.languages.map((lang) => (
                                    <div className='sm-cnt-btn'>
                                        <img className='sm-logo-btn' src={lang[1]} alt="" />
                                        <div>{lang[0]}</div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div>
                        <div className="grid-title">Mobile Development</div>
                        <hr></hr>
                        <div className='cnt-grid-logo'>
                            {
                                myDetails.skills.mobile_dev.map((lib) => (
                                    <div className='sm-cnt-btn'>
                                        <img className='sm-logo-btn' src={lib[1]} alt="" />
                                        <div>{lib[0]}</div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div>
                        <div className="grid-title">ML / AI</div>
                        <hr></hr>
                        <div className='cnt-grid-logo'>
                            {
                                myDetails.skills.ml_ai.map((lib) => (
                                    <div className='sm-cnt-btn'>
                                        <img className='sm-logo-btn' src={lib[1]} alt="" />
                                        <div>{lib[0]}</div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div>
                        <div className="grid-title">Tools</div>
                        <hr></hr>
                        <div className='cnt-grid-logo'>
                            {
                                myDetails.skills.tools.map((tool) => (
                                    <div className='sm-cnt-btn'>
                                        <img className='sm-logo-btn' src={tool[1]} alt="" />
                                        <div>{tool[0]}</div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div>
                        <div className="grid-title">Web Development</div>
                        <hr></hr>
                        <div className='cnt-grid-logo'>
                            {
                                myDetails.skills.full_stack.map((lib) => (
                                    <div className='sm-cnt-btn'>
                                        <img className='sm-logo-btn' src={lib[1]} alt="" />
                                        <div>{lib[0]}</div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div>
                        <div className="grid-title">Databases</div>
                        <hr></hr>
                        <div className='cnt-grid-logo'>
                            {
                                myDetails.skills.database.map((lib) => (
                                    <div className='sm-cnt-btn'>
                                        <img className='sm-logo-btn' src={lib[1]} alt="" />
                                        <div>{lib[0]}</div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div>
                        <div className="grid-title">Cloud & DevOps</div>
                        <hr></hr>
                        <div className='cnt-grid-logo'>
                            {
                                myDetails.skills.cloud_devops.map((lib) => (
                                    <div className='sm-cnt-btn'>
                                        <img className='sm-logo-btn' src={lib[1]} alt="" />
                                        <div>{lib[0]}</div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
                <BackBtn title={page_title} />
            </div>
            <Footer />
        </div>
    );
}

export default Skills;